module.exports = __webpack_public_path__ + "img/sfondo-zuppa-contadina.f4fae361.png";